import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { User_Service } from 'app/core/user/user.service';
import { api_response } from 'app/shared/shared.types';

@Injectable()
export class Auth_Service {
    private _is_auth: boolean = false;
    private _is_admin: boolean = false;
    private _is_guest: boolean = false;

    constructor(
        private _http_client: HttpClient,
        private _us: User_Service
    ) {
        var token = localStorage.getItem('access_token');
        if (token != undefined && token != "undefined") {
            let t = AuthUtils._decodeToken(token);
            this._is_admin = t.role <= 1;
        }
    }

    set access_token(token: string) {
        localStorage.setItem('access_token', token);
    }
    get access_token(): string {
        var token = localStorage.getItem('access_token');
        if (token == 'undefined' || token == null) {
            localStorage.removeItem('access_token');
            return "";
        }
        return token;
    }


    get is_auth(): boolean {
        return this._is_auth && !this._is_guest;
    }
    get is_admin(): boolean {
        return this._is_admin;
    }
    get is_guest(): boolean {
        return this._is_guest;
    }


    forgot_password(email: string): Observable<any> {
        return this._http_client.post('api/auth/forgot-password', email);
    }

    reset_password(password: string): Observable<any> {
        return this._http_client.post('api/auth/reset-password', password);
    }

    sign_in(credentials: { email: string; password: string }): Observable<any> {
        if (this._is_auth) {
            return throwError('User is already logged in.');
        }

        return this._http_client.post('api/session/sign-in', credentials).pipe(
            switchMap((response: any) => {
                if (response) {
                    this.access_token = response.payload.access_token;
                    this._is_auth = true;

                    this._us.user = response.payload.user;
                    this._is_admin = response.payload.user.role <= 1;
                }
                return of(response);
            })
        );
    }

    sign_in_using_token(): Observable<any> {
        const token = this.access_token;
        const headers = new HttpHeaders().set('Authorization', token || '');

        return this._http_client
            .post('api/session/refresh-access-token', {}, { headers })
            .pipe(
                catchError(() =>
                    // Return false
                    of(false)
                ),
                switchMap((response: api_response<any>) => {
                    if (response) {
                        this.access_token = response.payload.access_token;
                        this._is_auth = true;

                        this._us.user = response.payload.user;
                        this._is_admin = response.payload.user.role == "ADMIN";
                        this._is_guest = response.payload.user.role == "GUEST";
                        return of(true);
                    }
                    return of(false);
                })
            );
    }

    sign_out(): Observable<any> {
        const token = this.access_token;
        const headers = new HttpHeaders().set('Authorization', token || '');
        return this._http_client
            .post('api/session/sign-out',  {}, { headers })
            .pipe(
                switchMap((response: any) => {
                    localStorage.removeItem('access_token');

                    this._is_auth = false;
                    this._is_admin = false;
                    return of(true);
                })
            );
    }

    check(): Observable<boolean> {
        if (this._is_auth) {
            return of(true);
        }
        if (!this.access_token) {
            return of(false);
        }
        if (AuthUtils.isTokenExpired(this.access_token)) {
            return of(false);
        }
        return this.sign_in_using_token();
    }
}
